module.exports = __webpack_public_path__ + "img/dark-mud-decal-08.6e3a00da.png";